import { BrokerPortalFeatureCodes, ExternalProgramCodes, ProductTag, RenewableSystemType } from '../enums';

export const HESLP_ALLOWED_SYSTEM_TYPES: ReadonlyArray<RenewableSystemType> = Object.freeze([
    RenewableSystemType.Solar,
    RenewableSystemType.Battery
]);

export const HESLP_MIN_BATTERY_CAPACITY_KWH = 5;

export interface HeslpFlaggedSystemType {
    type: RenewableSystemType;
    featureCode: string;
}

/**
 * HESLP equipment types that are offered only while their runtime feature flag is ON.
 * Order is the display order after the always-available Solar and Battery options.
 */
export const HESLP_FLAGGED_SYSTEM_TYPES: ReadonlyArray<HeslpFlaggedSystemType> = Object.freeze([
    { type: RenewableSystemType.Aircon, featureCode: BrokerPortalFeatureCodes.HeslpAirconAvailable },
    { type: RenewableSystemType.HeatPump, featureCode: BrokerPortalFeatureCodes.HeslpHeatPumpAvailable },
    { type: RenewableSystemType.SolarHotWater, featureCode: BrokerPortalFeatureCodes.HeslpHeatPumpAvailable },
    { type: RenewableSystemType.CeilingFan, featureCode: BrokerPortalFeatureCodes.HeslpCeilingFanAvailable }
]);

export const HESLP_GUIDELINES_URL =
    'https://www.energy.nsw.gov.au/sites/default/files/2026-08/Home-Energy-Saver-Loans-guidelines-20260805.pdf';

type ExternalProgramRecord = Record<string, string | undefined>;

export interface ExternalProgramSource {
    externalProgram?: string;
    extraFields?: ExternalProgramRecord;
    additionalData?: ExternalProgramRecord;
}

export function resolveExternalProgram(source?: ExternalProgramSource): string | undefined {
    if (!source) return undefined;

    return (
        source.externalProgram ||
        source.extraFields?.externalprogram ||
        source.extraFields?.externalProgram ||
        source.additionalData?.externalProgram ||
        source.additionalData?.['extraFieldsDict.externalprogram']
    );
}

export function isExternalProgram(source: ExternalProgramSource | undefined, programCode: string): boolean {
    return resolveExternalProgram(source) === programCode;
}

export function isHeslp(source?: ExternalProgramSource): boolean {
    return isExternalProgram(source, ExternalProgramCodes.HESLP);
}

export function isHeslpRenewableInterestFreeApplication(
    productTag: ProductTag,
    source?: ExternalProgramSource
): boolean {
    return productTag === ProductTag.RenewableInterestFree && isHeslp(source);
}
